import { TbBuildingFactory2, TbContainer, TbUsersGroup } from "react-icons/tb";

export const base_reports = [
  {
    name: "По оборудованию",
    desc: "Сформировать отчет на основе данных о загрузке и использовании оборудования.",
    to: "/report/equipments",
    type: "equipments",
    icon: <TbContainer size={20} />,
  },
  {
    name: "По сотрудникам",
    desc: "Сформировать отчет на основе данных по сотрудникам предприятия.",
    to: "/report/persons",
    type: "persons",
    icon: <TbUsersGroup size={20} />,
  }
];